import { AlexaDevice } from '@/types/device';
import { api } from '../../api';

type ImportDeviceBody =
  | { type: 'ALEXA'; deviceEndpoint: string; organisationId?: number }
  | { type: 'HEX_NODE_TABLET'; tabletId: string; organisationId?: number };

/**
 * This API endpoint is used to fetch a list of floating devices
 * and import new devices into the platform.
 */
const deviceImportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFloatingDevices: builder.query<AlexaDevice[], void>({
      query: () => ({
        url: '/device-import',
        method: 'GET',
      }),
      providesTags: ['UnimportedDevices'],
    }),
    importDevice: builder.mutation<void, ImportDeviceBody>({
      query: (body) => ({
        url: '/device-import',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['UnimportedDevices', 'Devices'],
    }),
  }),
});

export const { useGetFloatingDevicesQuery, useImportDeviceMutation } =
  deviceImportApi;
